import { type TabbedSelectOption } from '../../../resources/js/components/TabbedSelect/TabbedSelect';
import React, { type MouseEvent, type ReactNode, type JSX } from 'react';
import {
  type LinkWrapper,
  type LinkWrapperProps,
} from '@resources/js/components/LinkWrapper/LinkWrapper';
import ArchonLinkWrapper from '../LinkWrapper/LinkWrapper';

export type TabbedSelectLinkOptionWrapperProps = {
  option: TabbedSelectOption;
  children: ReactNode;
  dynamicQueryParamsToIgnore?: string[];
  navigate?: (
    event: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
  ) => void | Promise<void>;
  LinkWrapper?: LinkWrapper;
} & Partial<LinkWrapperProps>;

export default function TabbedSelectLinkOptionWrapper({
  option,
  children,
  dynamicQueryParamsToIgnore,
  navigate,
  LinkWrapper = ArchonLinkWrapper,
  ...rest
}: TabbedSelectLinkOptionWrapperProps): JSX.Element {
  if (option.url) {
    return (
      <LinkWrapper
        {...rest}
        href={option.url}
        scroll={false}
        dynamicQueryParamsToIgnore={dynamicQueryParamsToIgnore}
        onClick={navigate}
      >
        {children}
      </LinkWrapper>
    );
  }

  return <>{children}</>;
}
